import { ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import { PageModel, SortModel } from 'src/app/rent-module/components/task-assignment-list-unassigned/abstract-task-assignment-list';
import { Protocol } from 'src/app/rent-module/shared/entities/protocol/protocol';
import { TasksService } from 'src/app/rent-module/shared/services/tasks/tasks.service';
import { PrimeNGSeverity } from 'src/app/shared-module/shared/types/primeng-severity.type';
import { OrderOperatedRentalTaskListProtocolViewDataSource } from './order-operated-rental-task-list-protocol-view.datasource';

@Component({
  selector: 'app-order-operated-rental-task-list-protocol-view',
  templateUrl: './order-operated-rental-task-list-protocol-view.component.html',
  styleUrls: ['./order-operated-rental-task-list-protocol-view.component.scss'],
})
export class OrderOperatedRentalTaskListProtocolViewComponent implements OnDestroy {

  // types
  public typesModel: any[] = [];
  public typeOptions = [
    { id: 'nexcore_operated_rental_task', name: 'Bedieneinsatz', label: 'Bedieneinsatz' }
  ];
  public defaultTypesModel = undefined; // load all types by default

  // sorting
  public sortModel: SortModel;
  public sortOptions : SortModel[] = [
    { label: 'Erledigt absteigend', fieldName: 'completedDateTime', direction: "desc"},
    { label: 'Erledigt aufsteigend', fieldName: 'completedDateTime', direction: "asc"}
  ];
  public defaultSortModel: SortModel = this.sortOptions[0];

  // states (not filterable at the moment)
  public states = ['COMPLETED'];

  // pagination
  public pageModel: PageModel;
  public defaultPageModel: PageModel = { pageNumber: 0, pageSize : 5 };

  public _orderId: string | undefined;

  // indicates loading
  public loading = false;

  public dataSource: OrderOperatedRentalTaskListProtocolViewDataSource;

  @Input() set orderId(orderId: any) {
    this._orderId = orderId;
    this.loadTasks();
  }

  constructor(
    private apollo: Apollo,
    public tasksService: TasksService,
    private cdRef:ChangeDetectorRef,
    private translate: TranslateService
  ) {
    // Initialize translated options
    this.typeOptions = [
      { id: 'nexcore_operated_rental_task', name: this.translate.instant('orderModule.orderOperatedRentalTaskListProtocolViewComponent.typeOptions.operatedRentalTask'), label: this.translate.instant('orderModule.orderOperatedRentalTaskListProtocolViewComponent.typeOptions.operatedRentalTask') }
    ];
    this.sortOptions = [
      { label: this.translate.instant('orderModule.orderOperatedRentalTaskListProtocolViewComponent.sortOptions.completedDesc'), fieldName: 'completedDateTime', direction: "desc"},
      { label: this.translate.instant('orderModule.orderOperatedRentalTaskListProtocolViewComponent.sortOptions.completedAsc'), fieldName: 'completedDateTime', direction: "asc"}
    ];
    this.defaultSortModel = this.sortOptions[0];
    this.pageModel = this.defaultPageModel;
    this.sortModel = this.defaultSortModel;
    this.typesModel = this.defaultTypesModel;
    this.dataSource = new OrderOperatedRentalTaskListProtocolViewDataSource(this.apollo);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
  }

  loadTasks() {
    if (this._orderId) {
      this.dataSource.loadTaskList({
        orderId: this._orderId,
        states: this.states,
        types: this.typesModel?.map(type => type.id),
        sortProperty: this.sortModel?.fieldName,
        sortDirection: this.sortModel?.direction,
        pageNumber: this.pageModel?.pageNumber,
        pageSize: this.pageModel?.pageSize,
      });
    }
  }

  refetchTasks(force = false): void {
    this.dataSource.refetchQuery({
      orderId: this._orderId,
      states: this.states,
      types: this.typesModel?.map(type => type.id),
      sortProperty: this.sortModel?.fieldName,
      sortDirection: this.sortModel?.direction,
      pageNumber: this.pageModel?.pageNumber,
      pageSize: this.pageModel?.pageSize,
    }, force);
  }

  ngOnDestroy(): void {
    this.dataSource.disconnect();
  }

  onPageChange(event) {
    this.pageModel = { pageNumber: event.page, pageSize: event.rows };
    this.refetchTasks();
  }

  getProtocolStateLabel(protocol: Protocol): string | undefined {
    return Protocol.getStateLabel(protocol);
  }

  getProtocolStateSeverity(protocol: Protocol): PrimeNGSeverity | undefined {
    return Protocol.getStateSeverity(protocol);
  }
}
